import { render, staticRenderFns } from "./OrderStock.vue?vue&type=template&id=d588452e&scoped=true&"
import script from "./OrderStock.vue?vue&type=script&lang=js&"
export * from "./OrderStock.vue?vue&type=script&lang=js&"
import style0 from "./OrderStock.vue?vue&type=style&index=0&id=d588452e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d588452e",
  null
  
)

export default component.exports